<i [ngClass]="design"></i>
